<div>
    <mat-progress-bar mode="indeterminate" *ngIf="IsLoading && !ErrorMessage"></mat-progress-bar>
    <div *ngIf="ErrorMessage" @flyIn class="error">
        <mat-icon>error</mat-icon>
        <div class="error-text">Fail to retrive data. <b>{{ErrorMessage}}</b></div>
    </div>
</div>